"use client";

import React, { useEffect, useRef, useState } from "react";
import { ShieldCheck, Dices, Target, Lock } from "lucide-react";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
type UseRevealOnScrollOptions = {
  once?: boolean;
  threshold?: number | number[];
  rootMargin?: string;
};
function useRevealOnScroll<T extends HTMLElement = HTMLElement>({
  once = true,
  threshold = 0.2,
  rootMargin = "0px"
}: UseRevealOnScrollOptions = {}) {
  const ref = useRef<T | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) {
      return;
    }
    if (typeof window === "undefined" || typeof IntersectionObserver === "undefined") {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (entry?.isIntersecting) {
        setIsVisible(true);
        if (once) {
          observer.unobserve(entry.target);
        }
      } else if (!once) {
        setIsVisible(false);
      }
    }, {
      threshold,
      rootMargin
    });
    observer.observe(node);
    return () => {
      observer.disconnect();
    };
  }, [once, rootMargin, threshold]);
  return {
    ref,
    isVisible
  };
}
const mechanicsData = [{
  id: "item-1",
  title: "EICR Inspections",
  content: "Electrical Installation Condition Reports are a legal requirement for landlords and essential for homeowners. Our certified engineers conduct thorough testing to identify any potential fire hazards or electric shock risks within your property.",
  icon: ShieldCheck
}, {
  id: "item-2",
  title: "Fuse Board Upgrades",
  content: "Modern consumer units provide vital protection that older fuse boxes lack. We install high-specification boards with RCD protection, ensuring your electrical system meets current BS 7671 safety standards and protects your family.",
  icon: Lock
}, {
  id: "item-3",
  title: "Legal Compliance",
  content: "Stay ahead of regulations with our comprehensive compliance audits. We provide all necessary certification for domestic and commercial properties, ensuring your insurance remains valid and your premises are legally safe.",
  icon: Target
}, {
  id: "item-4",
  title: "Safety First Approach",
  content: "Every installation we perform is backed by rigorous testing. From minor repairs to full rewires, we prioritize the integrity of your electrical infrastructure, using only high-quality components and precision engineering.",
  icon: Dices
}];
export default function FairPlayMechanics() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: leftColRef,
    isVisible: isLeftColVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: rightColRef,
    isVisible: isRightColVisible
  } = useRevealOnScroll<HTMLDivElement>();
  return <section data-section-id="240109" id="safety-compliance" className="bg-background text-foreground relative overflow-hidden py-24 lg:py-32 dark">
      {}
      <div className="pointer-events-none absolute top-0 left-0 h-[500px] w-[500px] -translate-x-1/2 -translate-y-1/2 rounded-lg bg-ring/5 blur-[120px]" />
      <div className="pointer-events-none absolute right-0 bottom-0 h-[600px] w-[600px] translate-x-1/3 translate-y-1/3 rounded-lg bg-accent/10 blur-[150px]" />

      
    </section>;
}